import { getCorrectCannotApplyMsg } from "contractor/components/utils/jobs";

const CannotApplyMessage = props => {
  const { contractor, hasPermission, job, jobListing } = props;

  return getCorrectCannotApplyMsg(job, jobListing, contractor, hasPermission);
};
export default CannotApplyMessage;
